export default {
    "account": {
        "allow_edit_phone_number": true,
        "show_phone_labels": false
    },
    "agent": {},
    "allowed_sections": {
        "account": true,
        "agent": true,
        "appstore": true,
        "authentication": true,
        "auto": true,
        "build": true,
        "claims": true,
        "contacts": true,
        "dashboard": true,
        "documents": true,
        "e_delivery": true,
        "email_templates": true,
        "enrollment": true,
        "global": true,
        "help": true,
        "homepage": true,
        "insured_profile": true,
        "invoices": true,
        "kubernetes": true,
        "login": true,
        "messaging": true,
        "notifications": true,
        "payments": true,
        "policies": true,
        "reset_password": true,
        "smoke_tests": true,
        "tests": true,
        "watercraft": true
    },
    "appstore": {
        "allow_user_to_disable_redesign2024": false,
        "mobile_application_name": "Insured Portal",
        "redesign2024": false,
        "redesign2024_social_login_buttons": false
    },
    "authentication": {
        "hide_pin": false,
        "mfa_mode": "optional",
        "session_expiration_time": 600
    },
    "auto": {},
    "britecore_url": "https://farmersmutual-briteapps.britecore.com",
    "build": {
        "scss_desktop": "",
        "scss_mobile": ""
    },
    "claims": {
        "always_show_claims_menu_link": false,
        "claims_enabled": true,
        "file_claim_by_form": false,
        "hide_claims_adjusters": false,
        "hide_claims_loss_photos": false,
        "hide_upload_photos_and_update_claim": false,
        "require_contact_phone_new_claim": false
    },
    "company_id": "655117e8-6f92-4a23-87e2-8238455b971c",
    "contacts": {},
    "dashboard": {},
    "documents": {},
    "e_delivery": {
        "e_delivery_acknowledgement": true,
        "enable_e_delivery": false,
        "send_notification_to_enrolled_co_insured_if_recipient_not_enrolled": true,
        "use_bc_email_if_no_email_in_ba": false,
        "use_unconfirmed_ba_email": false
    },
    "email_templates": {},
    "enrollment": {
        "allow_adding_additional_phone_numbers": false,
        "required_password_strength": 3,
        "send_email_on_auto_enrollment": false,
        "send_portal_code_via_email": true,
        "send_portal_code_via_sms": true,
        "show_detailed_error_information_on_policy_lookup": true,
        "terms_of_service": false,
        "use_additional_verification_password_field": false,
        "use_dob_if_available": true,
        "use_link_in_auto_enrollment_email": false,
        "use_ssn_if_available": true,
        "use_user_based_search_during_enrollment": false,
        "users_are_identified_by_email_address": true,
        "where_do_i_find_enrollment_code_message": ""
    },
    "global": {
        "allowed_files_to_upload": "image/*, video/*, application/pdf, .xls, .xlsx, .doc, .docx, .txt, .rtf",
        "application_versions_supported": "version_web_and_mobile",
        "aws_custom_translation": "<tmx version=\"1.4\"><header creationtool=\"XYZTool\" creationtoolversion=\"0\" datatype=\"PlainText\" segtype=\"sentence\" adminlang=\"en\" srclang=\"en\" o-tmf=\"test\"/><body><tu><tuv  xml:lang=\"en\"><seg>policy</seg></tuv><tuv xml:lang=\"es\"><seg>p\u00f3liza</seg></tuv></tu><tu><tuv xml:lang=\"en\"><seg>Policy</seg></tuv><tuv xml:lang=\"es\"><seg>P\u00f3liza</seg></tuv></tu><tu><tuv  xml:lang=\"en\"><seg>policies</seg></tuv><tuv xml:lang=\"es\"><seg>p\u00f3lizas</seg></tuv></tu><tu><tuv xml:lang=\"en\"><seg>Policies</seg></tuv><tuv xml:lang=\"es\"><seg>P\u00f3lizas</seg></tuv></tu></body></tmx>",
        "aws_language": "{\"english\": \"en\", \"spanish\": \"es\", \"french\": \"fr\"}",
        "carrier_additional_wording": false,
        "carrier_name": "Farmers Mutual Insurance Company",
        "carrier_website_address": "",
        "currency_format": "$0.00",
        "default_font": "font-galano-grotesque",
        "display_spanish_link": true,
        "edelivery_expiration_age": 180,
        "electronic_delivery_option": true,
        "emails_expiration_age": 180,
        "enable_aws_translation": true,
        "enable_touch_id": false,
        "google_maps_api_key": "AIzaSyC-rMrsauObzwbIr2wbX8oJadjNvfEhXkM",
        "hide_agent_and_agency_contact_info": false,
        "hide_agent_emails": false,
        "hide_agent_loss_photos": false,
        "hide_agent_property_photos": false,
        "hide_location_details": false,
        "insured_messages_expiration_age": 180,
        "language": "english",
        "mobile_application_version": "0.24",
        "privacy_policy_url": "",
        "show_canceled_policies": false,
        "text_message_expiration_age": 180,
        "use_type_label_for_other_addresses": false,
        "user_actions_expiration_age": 360
    },
    "help": {},
    "homepage": {},
    "insured_profile": {},
    "invoices": {},
    "kubernetes": {
        "env_tls_issuer": "farmersmutual-briteapps-letsencrypt-staging"
    },
    "login": {},
    "messaging": {},
    "notifications": {
        "additional_email_addresses_to_notify_when_insured_enables_auto_pay": "",
        "additional_email_addresses_to_notify_when_insured_uploads_a_file": "",
        "additional_email_addresses_to_notify_when_insured_uploads_a_property_photo": "",
        "additional_email_addresses_to_notify_whenever_claim_is_filled": "",
        "additional_email_addresses_to_notify_whenever_insured_changes_payment_plan": "",
        "additional_email_addresses_to_notify_whenever_insured_updates_email_address": "",
        "additional_email_addresses_to_notify_whenever_insured_updates_his_phone": "",
        "enable_old_edelivery": false,
        "notify_to_agency_when_insureds_enable_auto_pay": false,
        "notify_to_agency_whenever_insured_changes_payment_plan": false,
        "notify_to_agency_whenever_insured_files_a_claim": false,
        "notify_to_agency_whenever_insured_updates_email_address": false,
        "notify_to_agency_whenever_insured_updates_his_phone": false,
        "notify_to_agency_whenever_insured_uploads_a_file": false,
        "notify_to_agency_whenever_insured_uploads_a_property_photo": false,
        "notify_to_agent_whenever_insured_changes_payment_plan": false,
        "notify_to_agent_whenever_insured_files_a_claim": false,
        "notify_to_agent_whenever_insured_updates_email_address": false,
        "notify_to_agent_whenever_insured_updates_his_phone": false,
        "notify_to_agent_whenever_insured_uploads_a_file": false,
        "notify_to_agent_whenever_insured_uploads_a_property_photo": false,
        "notify_to_agents_when_insureds_enable_auto_pay": false,
        "send_emails_from": "noreply@briteapps.com"
    },
    "payments": {
        "allow_add_billing_address": true,
        "allow_auto_pay": true,
        "allow_auto_pay_change_on_escrow": false,
        "allow_billing_schedule_change": false,
        "allow_next_term_payments": true,
        "allow_payment_reminders": true,
        "auto_pay_confirmation_modal": false,
        "auto_pay_read_only": false,
        "autopay_payment_methods": "ap_ba_and_cc",
        "available_payment_methods": "ba_and_cc",
        "disable_payment_functionality": false,
        "display_payment_schedule_preview": false,
        "payment_schedule": "invoices_payments",
        "show_cc_processing_fee_warning": false,
        "show_payment_plan": true,
        "url_to_external_payment_site": "",
        "use_external_payment_site": false
    },
    "policies": {
        "group_vehicles_by_type": false,
        "only_display_agency_contact_information": false,
        "read_only_documents_section": false,
        "read_only_property_photos": false,
        "show_declaration_link": false
    },
    "reset_password": {},
    "smoke_tests": {
        "policy_number": "10-2014-3",
        "portal_code": "6769"
    },
    "tests": {},
    "watercraft": {}
}